var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rv2-gene-kg" },
    [
      _c("header", { staticClass: "rv2-gene-kg-head" }, [
        _c("div", { staticClass: "rv2-gene-kg-title-row" }, [
          _c("h3", { staticClass: "rv2-gene-kg-title" }, [
            _c("span", { staticClass: "rv2-gene-kg-gene" }, [
              _vm._v(_vm._s(_vm.geneLabel)),
            ]),
            _c("span", { staticClass: "rv2-gene-kg-subtitle" }, [
              _vm._v("CFDE knowledge graph"),
            ]),
          ]),
          _vm.loading
            ? _c("p", { staticClass: "rv2-gene-kg-status" }, [
                _vm._v("Loading associations…"),
              ])
            : _vm.error
            ? _c("p", { staticClass: "rv2-gene-kg-error" }, [
                _vm._v(_vm._s(_vm.error)),
              ])
            : _vm._e(),
        ]),
        !_vm.loading && !_vm.error && _vm.geneKg
          ? _c("div", { staticClass: "rv2-gene-kg-counts" }, [
              _c("span", { staticClass: "rv2-gene-kg-count" }, [
                _c("strong", [_vm._v(_vm._s(_vm.traitCount))]),
                _vm._v(" traits "),
              ]),
              _c("span", { staticClass: "rv2-gene-kg-count" }, [
                _c("strong", [_vm._v(_vm._s(_vm.factorCount))]),
                _vm._v(" factors "),
              ]),
              _c("span", { staticClass: "rv2-gene-kg-count" }, [
                _c("strong", [_vm._v(_vm._s(_vm.edgeCount))]),
                _vm._v(" edges "),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "rv2-gene-kg-loading",
              attrs: { "aria-busy": "true" },
            },
            [
              _vm._v(
                " Fetching gene↔trait, gene↔factor, then trait↔factor links among those sets… "
              ),
            ]
          )
        : _vm.geneKg && !_vm.error
        ? [
            !_vm.hasGraph
              ? _c("div", { staticClass: "rv2-gene-kg-empty" }, [
                  _vm._v(" No CFDE KG associations found for this gene. "),
                ])
              : [
                  _vm.geneKg.graph && _vm.geneKg.graph.nodes.length
                    ? _c("ScopeKgNetworkGraph", {
                        attrs: {
                          graph: _vm.geneKg.graph,
                          "node-caps": false,
                          "weight-filters": true,
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "rv2-gene-kg-lists" }, [
                    _c(
                      "section",
                      {
                        staticClass: "rv2-gene-kg-list-panel",
                        attrs: { "aria-labelledby": "rv2-kg-traits" },
                      },
                      [
                        _c("div", { staticClass: "rv2-gene-kg-list-head" }, [
                          _c(
                            "h4",
                            {
                              staticClass: "rv2-gene-kg-list-title",
                              attrs: { id: "rv2-kg-traits" },
                            },
                            [_vm._v("Traits")]
                          ),
                          _c("span", { staticClass: "rv2-gene-kg-list-meta" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.traitCount) +
                                " total · gene↔trait weight "
                            ),
                          ]),
                        ]),
                        _vm.allTraits.length
                          ? _c(
                              "div",
                              { staticClass: "rv2-gene-kg-table-wrap" },
                              [
                                _c(
                                  "table",
                                  { staticClass: "rv2-gene-kg-table" },
                                  [
                                    _vm._m(0),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.pagedTraits, function (row) {
                                        return _c("tr", { key: row.trait }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                row.traitLabel || row.trait
                                              )
                                            ),
                                          ]),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "rv2-gene-kg-score-col",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatWeight(row.weight)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ])
                                      }),
                                      0
                                    ),
                                  ]
                                ),
                                _vm.traitCount > _vm.perPage
                                  ? _c("b-pagination", {
                                      staticClass:
                                        "rv2-gene-kg-pagination pagination-sm justify-content-center",
                                      attrs: {
                                        "total-rows": _vm.traitCount,
                                        "per-page": _vm.perPage,
                                        size: "sm",
                                        "aria-controls": "rv2-kg-traits",
                                      },
                                      model: {
                                        value: _vm.traitPage,
                                        callback: function ($$v) {
                                          _vm.traitPage = $$v
                                        },
                                        expression: "traitPage",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c("p", { staticClass: "rv2-gene-kg-list-empty" }, [
                              _vm._v("None"),
                            ]),
                      ]
                    ),
                    _c(
                      "section",
                      {
                        staticClass: "rv2-gene-kg-list-panel",
                        attrs: { "aria-labelledby": "rv2-kg-factors" },
                      },
                      [
                        _c("div", { staticClass: "rv2-gene-kg-list-head" }, [
                          _c(
                            "h4",
                            {
                              staticClass: "rv2-gene-kg-list-title",
                              attrs: { id: "rv2-kg-factors" },
                            },
                            [_vm._v("Factors")]
                          ),
                          _c("span", { staticClass: "rv2-gene-kg-list-meta" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.factorCount) +
                                " total · gene↔factor weight "
                            ),
                          ]),
                        ]),
                        _vm.allFactors.length
                          ? _c(
                              "div",
                              { staticClass: "rv2-gene-kg-table-wrap" },
                              [
                                _c(
                                  "table",
                                  { staticClass: "rv2-gene-kg-table" },
                                  [
                                    _vm._m(1),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.pagedFactors, function (row) {
                                        return _c("tr", { key: row.factor }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                row.factorLabel || row.factor
                                              )
                                            ),
                                          ]),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "rv2-gene-kg-score-col",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatWeight(row.weight)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ])
                                      }),
                                      0
                                    ),
                                  ]
                                ),
                                _vm.factorCount > _vm.perPage
                                  ? _c("b-pagination", {
                                      staticClass:
                                        "rv2-gene-kg-pagination pagination-sm justify-content-center",
                                      attrs: {
                                        "total-rows": _vm.factorCount,
                                        "per-page": _vm.perPage,
                                        size: "sm",
                                        "aria-controls": "rv2-kg-factors",
                                      },
                                      model: {
                                        value: _vm.factorPage,
                                        callback: function ($$v) {
                                          _vm.factorPage = $$v
                                        },
                                        expression: "factorPage",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c("p", { staticClass: "rv2-gene-kg-list-empty" }, [
                              _vm._v("None"),
                            ]),
                      ]
                    ),
                  ]),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Trait")]),
        _c(
          "th",
          { staticClass: "rv2-gene-kg-score-col", attrs: { scope: "col" } },
          [_vm._v("Weight")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Factor")]),
        _c(
          "th",
          { staticClass: "rv2-gene-kg-score-col", attrs: { scope: "col" } },
          [_vm._v("Weight")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }